<template>
  <div style="background-color: #fff">
    <el-container class="page">
      <!-- 侧边栏拖拽部分 -->
      <el-aside class="right-box-shodow padding-20">
        <el-collapse v-model="activeName">
          <el-collapse-item
            v-for="(item, index) in icons"
            :key="index"
            :title="item.title"
            :name="index + 1"
          >
            <ul>
              <li
                v-for="(sitem, sindex) in item.chliden"
                draggable="true"
                @dragstart="dragstart($event, sitem)"
                :key="sindex"
              >
                <i :class="'icon-' + sitem.icon"></i>
                <span>{{ sitem.name }}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
      <!-- 主体部分gojs -->
      <el-main class="padding-0" style="padding: 20px 20px 0px 20px">
        <div class="tools-bar">
          <div class="tools-controller">
            <!-- 放大，缩小等操作 -->
            <div
              class="icons"
              v-for="(item, index) in control"
              :key="index"
              @click="controllerClick(item)"
            >
              <i :class="'icons-' + item.icon"></i><span>{{ item.name }}</span>
            </div>
            <!-- 测试执行和正式发送 -->
            <div class="btnf">
              <el-tooltip
                class="item"
                effect="dark"
                content="仅测试流程是否正确执行，不会发送短信"
                placement="top-start"
              >
                <el-button
                  type="primary"
                  @click="testMSG"
                  class="testpush"
                  :style="{
                    'background-color': globalBG,
                    'border-color': globalBG,
                  }"
                  ><i style="font-size: 17px" class="el-icon-video-play"></i>
                  测试执行</el-button
                >
              </el-tooltip>
              <el-button
                type="primary"
                @click="exec"
                class="officialpush"
                :style="{
                  'background-color': globalBG,
                  'border-color': globalBG,
                }"
                ><i style="font-size: 17px" class="el-icon-s-promotion"></i>
                正式发送</el-button
              >
            </div>
          </div>
          <!-- 全屏按钮，引入的插件screenfull -->
          <div class="tools-btns">
            <div id="FullScreen">
              <full-screen></full-screen>
            </div>
            <div class="icons" @click="preview">
              <span>预览小图</span><i class="icons-preview"></i>
            </div>
          </div>
        </div>
        <!-- gojs -->
        <div class="canvas-box" ref="canvas" @drop="drop" @dragover.prevent>
          <diagram
            ref="diag"
            :isOverview="isOverview"
            :edit="edit"
            :model-data="diagramData"
            :is-read-only.sync="isReadOnly"
            @model-changed="modelChanged"
            @changed-selection="changedSelection"
            @object-double-clicked="objectDoubleClicked"
            @object-delete="objectDelete"
            @LinkDrawn="LinkDrawn"
            @select-tion-moved="nodeView"
          >
          </diagram>
          <!-- 合并 -->
          <merge-dialog
            v-if="mergeVisible"
            :visible.sync="mergeVisible"
            :is-read-only.sync="isReadOnly"
            :node-id="nodeId"
            :marketing-id="id"
            @change-name="changedName"
          >
          </merge-dialog>
          <!-- 排除 -->
          <exclude-dialog
            v-if="excludeVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="excludeVisible"
            @change-name="changedName"
          >
          </exclude-dialog>
          <!-- 交集 -->
          <intersection-dialog
            v-if="intersectionVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="intersectionVisible"
            @change-name="changedName"
          >
          </intersection-dialog>
          <!-- 抽取 -->
          <extraction-dialog
            v-if="extractionVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="extractionVisible"
            @change-name="changedName"
            @change="extractionChange"
          >
          </extraction-dialog>
          <!-- 排重 -->
          <unique-dialog
            v-if="uniqueVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="uniqueVisible"
            @change="extractionChange"
            @change-name="changedName"
          ></unique-dialog>
          <!-- 另存为模板弹框 -->
          <el-dialog
            title="另存为模板"
            width="500px"
            :visible.sync="dialogTemplateFormVisible"
            :close-on-click-modal="false"
          >
            <el-form :model="formTemplate" :rules="rulest" ref="formTemplate">
              <el-form-item label="模板名称" prop="name" :label-width="'90px'">
                <el-input
                  v-model="formTemplate.name"
                  autocomplete="off"
                  maxlength="20"
                >
                  <span
                    slot="suffix"
                    style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    "
                    >{{ formTemplate.name.length }}/20</span
                  >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogTemplateFormVisible = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="saveAsTemplate" v-preventReClick
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
        <!-- 底部 -->
        <div style="float:right;color:#e6a23c;margin-bottom:10px;">
          温馨提示：出现节点设置异常，鼠标移入
            "<img  :src="imagePicture"
              style="width:12px;height:12px;vertical-align:middle">"
          可查看错误信息！</div>
      </el-main>
    </el-container>

    <!-- 会员分群 -->
    <membership-dialog
      v-if="vipVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="vipVisible"
      @change-name="changedName"
    >
    </membership-dialog>
    <!-- 短信 -->
    <sms-send-dialog
      v-if="msgVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="msgVisible"
      @change-name="changedName"
    ></sms-send-dialog>
    <!-- 短信分析 -->
    <sms-analysis
      v-if="analyzeVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :visible.sync="analyzeVisible"
      @change-name="changedName"
    ></sms-analysis>
    <!-- 等待节点 -->
    <await-dialog
      v-if="awaitVisible"
      :visible.sync="awaitVisible"
      :is-read-only.sync="isReadOnly"
      @change-name="changedName"
      :marketing-id="id"
      :node-id="nodeId"
    ></await-dialog>
    <exec-dialog
      v-if="execVisible"
      :visible.sync="execVisible"
      :marketing-id="id"
      @change="excChange"
    ></exec-dialog>
  </div>
</template>
<script>
import FullScreen from "@/components/fullScreen";
import diagram from "./diagram";
import membershipDialog from "./membershipDialog";
import smsSendDialog from "./smsSendDialog";
import smsAnalysis from "./smsAnalysis";
import awaitDialog from "./awaitDialog";
import execDialog from "./execDialog";
import { mapState } from "vuex";
import mergeDialog from "./mergeDialog"; //合并
import excludeDialog from "./excludeDialog"; //排除
import intersectionDialog from "./intersectionDialog"; //交集
import extractionDialog from "./extractionDialog"; //抽取
import uniqueDialog from "./uniqueDialog"; //排重
import mnode from "@/api/intelligentMarket/a_node";
var activityInterval = null;
export default {
  name: "ItemDetail",
  data() {
    return {
      imagePicture:require("@/assets/imagesZhi/close.png"),
      id: 0,
      app: "",
      nodeId: "",
      isov: false, //预览小图
      isReadOnly: false,
      edit: true,
      isReset: false,
      isOverview: false,
      diagramData: {
        nodeDataArray: [],
        linkDataArray: [],
      },
      activeName: [1, 2, 3, 4, 5, 6],
      icons: [
        {
          title: "目标客户",
          chliden: [
            {
              icon: "vip",
              name: "客户分群",
              index: 1,
            },
          ],
        },
        {
          title: "目标筛选",
          chliden: [
            {
              icon: "merge",
              name: "合并",
              index: 2,
            },
            {
              icon: "extraction",
              name: "抽取",
              index: 3,
            },
            {
              icon: "intersection",
              name: "交集",
              index: 4,
            },
            {
              icon: "exclude",
              name: "排除",
              index: 5,
            },
            {
              icon: "unique",
              name: "排重",
              index: 6,
            },
          ],
        },
        {
          title: "执行方式",
          chliden: [
            {
              icon: "await",
              name: "等待",
              index: 10,
            },
          ],
        },
        {
          title: "触达方式",
          chliden: [
            {
              icon: "msg",
              name: "短信",
              index: 7,
            },
          ],
        },
        {
          title: "营销分析",
          chliden: [
            {
              icon: "analyze__msg",
              name: "短信分析",
              index: 8,
            },
          ],
        },
      ],
      control: [
        {
          event: "reset",
          icon: "reset",
          name: "恢复编辑",
        },
        {
          icon: "zoomOut",
          name: "放大",
        },
        {
          icon: "zoomIn",
          name: "缩小",
        },
        {
          icon: "copy",
          name: "复制",
        },
        {
          icon: "delete",
          name: "删除",
        },
        {
          icon: "saveAs",
          name: "另存为模板",
        },
        {
          icon: "help",
          name: "使用帮助",
        },
      ],
      currentNode: null,
      currentLink: null,
      isOverview: false,
      isov: false,
      /**另存为弹框 */
      dialogTemplateFormVisible: false,
      formTemplate: {
        intelligentMarketingId: "",
        name: "",
      },
      rulest: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      /***合并 */
      mergeVisible: false,
      /***排除 */
      excludeVisible: false,
      /***交集 */
      intersectionVisible: false,
      /***抽取 */
      extractionVisible: false,
      /***排重 */
      uniqueVisible: false,
      vipVisible: false, // 会员分群弹窗节点
      msgVisible: false, // 短信弹窗
      analyzeVisible: false, // 短信分析弹窗节点
      awaitVisible: false, // 等待节点
      execVisible: false, // 正式发送节点
      marketingDetail: null,
      isTest: true,
      isExec: true,
      resetdata: 5,
    };
  },
  created() {
    this.$data.id = Number(this.$route.query.id);
    this.$data.editStatus = this.$route.query.status || "";
    //进入页面中调取的列表
    this.setinit();
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  components: {
    FullScreen,
    diagram,
    mergeDialog,
    membershipDialog,
    smsSendDialog,
    excludeDialog,
    intersectionDialog,
    extractionDialog,
    uniqueDialog,
    smsAnalysis,
    awaitDialog,
    execDialog,
  },
  mounted() {},
  methods: {
    nodeView(e) {
      let diagram = this.$refs.diag.diagram;
      let node = e.diagram.selection.first();
      setTimeout(() => {
        diagram.scrollToRect(node.actualBounds);
      }, 100);
    },
    excChange() {
      var data = this.diagramData.nodeDataArray;
      this.$data.marketingDetail = 1;
      this.changeVIew(1);
      data.forEach((sitem) => {
        sitem.resultCount = "";
        sitem.executionStatus = 0;
        sitem.isSaveContent = 1;
      });
      this.updateDiagramFromData();
    },
    updateDiagramFromData() {
      this.$refs.diag.updateDiagramFromData();
    },
    //操作了排重和抽取
    extractionChange() {
      this.setinit();
    },
    //刷新列表
    setinit(listNode) {
      mnode.getNodeList({ marketingId: this.$data.id }).then((res) => {
        if (res) {
          let diagramData = {
            nodeDataArray: res.nodeDataArray,
            linkDataArray: res.linkDataArray,
          };
          this.$data.diagramData = diagramData;
          this.$data.isReadOnly = res.marketingDetail !== 0;
          this.$data.isResets = res.marketingDetail === 2;
          this.$data.marketingDetail = res.marketingDetail;
          clearInterval(activityInterval);
          if (res.marketingDetail === 3) {
            this.changeVIew(0);
          }
          if (res.marketingDetail === 1) {
            this.changeVIew(1);
          }
          // if (listNode && listNode.length > 0) {
          //   listNode.forEach(item => {
          //     console.log('listNode:', item)
          //     diagram.select(diagram.findNodeForData(item));
          //   })
          // }
        }
      });
    },
    changeVIew(type, value) {
      var _that = this;
      if (type) {
        this.$data.isExec = false; //正式发送
      } else {
        this.$data.isTest = false; //测试发送
      }
      var interval = function() {
        mnode
          .getExecNodeResultCount({
            marketingId: this.$data.id,
          })
          .then((res) => {
            if (res.code == 1) {
              let model = this.model();
              model.startTransaction();
              // nodeResultCountDetailList智能营销节点，统计人数信息
              res.data.nodeResultCountDetailList.forEach((item) => {
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "resultCount",
                  item.resultCount == 0
                    ? ""
                    : item.resultCount == -1
                    ? ""
                    : item.resultCount
                );
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "executionStatus",
                  item.status
                );
                //节点信息报错鼠标移动提示
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "errorDesc",
                  item.errorDesc == null ? "" : item.errorDesc,
                );           
              });
              model.commitTransaction("updateStatus");
              if (res.data.status) {
                var _that = this;
                clearInterval(activityInterval);
                _that.info("活动执行结束！");
                if (type) {
                  this.$data.marketingDetail = 2;
                  this.$data.isExec = true;
                  this.$data.isResets = true;
                } else {
                  this.$data.marketingDetail = 4;
                  this.$data.isTest = true;
                }
              }
            }
          });
      };
      activityInterval = setInterval(interval.bind(this), type ? 5000 : 2000);
    },
    reset() {
      if (!this.$data.isResets) {
        mnode.redesignMarketing(this.$data.id).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.message);
            this.$data.isTest = true;
            this.setinit();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.info("正式执行后不能恢复编辑！");
      }
    },
    //节点连线返回500的时候，自动删除
    LinkDrawn(e) {
      let model = this.model();
      setTimeout(() => {
        mnode
          .updateNodeRel({
            marketingId: this.$data.id, //活动id
            parentId: this.currentLink.from,
            nodeId: this.currentLink.to,
          })
          .then((res) => {
            if (res.code == 1) {
            } else {
              model.removeLinkData(e.subject.data);
              this.$message.error(res.message);
            }
          })
          .catch((a) => {
            model.removeLinkData(e.subject.data);
          });
      }, 50);
    },
    //菜单拖拽
    dragstart(e, i) {
      //拖拽进来存的图标和名字，icon和index，name，其中dataTransfer是专门用来存储拖放的数据的
      e.dataTransfer.setData("text", JSON.stringify(i));
    },
    drop(e) {
      //计算被拖入图元的坐标
      if (!this.$data.isReadOnly) {
        let can = this.$refs.diag.$refs.diagram;
        let pixelratio = window.PIXELRATIO || 1;
        let bbox = can.getBoundingClientRect();
        let bbw = bbox.width;
        if (bbw === 0) bbw = 0.001;
        let bbh = bbox.height;
        if (bbh === 0) bbh = 0.001;
        let mx = e.clientX - bbox.left * (can.clientWidth / pixelratio / bbw);
        let my = e.clientY - bbox.top * (can.clientHeight / pixelratio / bbh);
        let point = this.$refs.diag.diagram.transformViewToDoc(
          new this.$go.Point(mx, my) //起点坐标
        );
        let item = JSON.parse(e.dataTransfer.getData("text"));
        let category = item.icon.split("__")[0];
        let data = {
          marketingId: this.$data.id, //后续需要放开
          type: item.index,
          name: item.name,
          text: item.name,
          category: category,
          coordinate: `${point.x.toFixed(2)},${point.y.toFixed(2)}`,
        };
        mnode.addNode(data).then((res) => {
          if (res) {
            data.nodeId = data.key = res.data;
            data.isSaveContent = category === "analyze";
            data.coordinate = `${point.x.toFixed(2)} ${point.y.toFixed(2)}`;
            this.$data.nodeId = res.data;
            this.addNode(data);
            // if (typeof this.$data[category + 'Visible'] !== 'undefined') {
            //   this.$data[category + 'Visible'] = !this.$data[category + 'Visible']
            // } else {
            //   this.addNode({})
            // }
          }
        });
      } else {
        this.readOnly();
      }
      e.preventDefault();
      e.stopPropagation();
    },

    //添加节点的方法
    addNode(ndata) {
      console.log("ndata:", ndata);
      let data = null;
      //获取gojs模型
      let model = this.model();
      data = JSON.parse(JSON.stringify(ndata));
      //所有模型更改都应该在事务模型中进行
      model.startTransaction();
      //添加节点数据，当您要将节点或者组添加到图中时，请使用新的数据对象调用此方法，这会将数据添加到
      // nodeDataArray并通知所有侦听器新的节点数据对象已插入到集合中。
      model.addNodeData(data);
      //提交当前事务的更改
      model.commitTransaction(`added Node`);
      // 选中当前项目
      let diagram = this.$refs.diag.diagram;
      // 选择 使给定对象成为唯一选定的对象，此方法会引发ChangingSelection和ChangedSelection图事假，在diagram中有。
      // findNodeForData查询与模型的节点数据对象相对应的节点或者组，节点数量发生变化改变
      diagram.select(diagram.findNodeForData(data));
    },
    //测试执行
    testMSG() {
      if (this.$data.marketingDetail == 2) {
        this.$message.error("当前活动已经结束！");
        return;
      }
      if (this.$data.marketingDetail == 1) {
        this.$message.error("当前活动正式执行中！");
        return;
      }
      if (this.$data.isTest && this.$data.isExec) {
        mnode.testIntelligentMarketing(this.$data.id).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.message);
            this.isReadOnly = true;
            this.$data.marketingDetail = 3;
            this.changeVIew(0, 66);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.info("执行中，请稍后再试！");
      }
    },
    //正式发送
    exec() {
      if (this.$data.marketingDetail === 2) {
        this.$message.error("当前活动已经结束！");
        return;
      }
      if (this.$data.marketingDetail === 1) {
        this.$message.error("当前活动正式执行中！");
        return;
      }
      if (
        this.$data.marketingDetail === 4 &&
        this.$data.isTest &&
        this.$data.isExec
      ) {
        this.execVisible = true;
      } else {
        if (!this.$data.isExec) {
          this.info("执行中，请稍后再试！");
        } else {
          this.info("请先执行测试发送！");
        }
      }
    },
    //预览小图
    preview() {},
    //访问GoJS图的GoJS模型
    model() {
      return this.$refs.diag.model();
    },
    //数据发生变化
    modelChanged(e) {
      //isTransactionFinished可以判断事件是否结束
      if (e.isTransactionFinished) {
        //e.oldValue === "Move"拖动节点放开时的数据改变
        if (e.oldValue === "Move" && this.edit) {
          //获取拖动节点的坐标
          let diagram = this.$refs.diag.diagram;
          var nodeOrLinkList = diagram.selection;
          var nodeNumList = [];
          nodeOrLinkList.each((nodeOrLink, index) => {
            nodeNumList.push(nodeOrLink.data);
          });
          if (nodeNumList.length > 1) {
            // 批量移动
            nodeNumList.forEach((v, index) => {
              if (nodeNumList[index].nodeId) {
                let coordinate = nodeNumList[index].coordinate.split(" ");
                nodeNumList[index].coordinate = `${parseInt(
                  coordinate[0]
                )},${parseInt(coordinate[1])}`;
                var param = {
                  nodeId: nodeNumList[index].nodeId,
                  coordinate: nodeNumList[index].coordinate,
                };
                mnode.updateCoordinate(param);
              }
            });
          } else {
            // 单独一个的移动
            let coordinate = this.currentNode.data.coordinate;
            coordinate = coordinate.split(" ");
            coordinate[0] = Number(coordinate[0]).toFixed(0); //获取x轴坐标
            coordinate[1] = Number(coordinate[1]).toFixed(0); //获取y轴坐标
            mnode.updateCoordinate({
              nodeId: this.currentNode.data.nodeId,
              coordinate: coordinate.join(","),
            });
          }
          console.log("length:", nodeNumList.length);
        }
        if (e.oldValue === "Paste") {
          console.dir(e.oldValue);
        }
        //节点连线调取接口
        if (e.oldValue === "Linking" && this.edit) {
          setTimeout(() => {}, 50);
        }
      }
    },
    //选择数据发生变化
    changedSelection(e) {
      //获取获得焦点的第一个元素，可为节点或者线。
      let node = e.diagram.selection.first();
      if (node instanceof this.$go.Node) {
        this.currentNode = node;
      } else {
        this.currentNode = null;
      }
      if (node instanceof this.$go.Link) {
        this.currentLink = JSON.parse(JSON.stringify(node.data));
        // this.numSure = this.currentLink.from;
      } else {
        this.currentLink = null;
      }
    },
    //双击点击事件
    objectDoubleClicked(e) {
      //this.currentNode.data是节点的具体信息
      let node = this.currentNode;
      if (node instanceof this.$go.Node && this.edit) {
        let category = node.data.category;
        //判断是否是目标人群，就是抽取和排重节点生成，只能在上一节点进行编辑
        if (category === "targetGroups") {
          this.info("请在上一级节点进行编辑");
          return;
        }
        //排重(unique)和排除(exclude)的节点，至少要链接两个人群数据源
        if (
          (category == "unique" || category == "exclude") &&
          node.findNodesInto().count < 2
        ) {
          this.$message.error("请至少链入两个人群数据源");
          return;
        }
        //短信分析的节点(analyze),必须要再短信发送后才可以查看营销效果
        if (category == "analyze") {
          //需要根据节点的状态返回来做确定，未打勾说明未开始营销
          if (
            this.$data.marketingDetail === 0 ||
            this.$data.marketingDetail === 4
          ) {
            this.$message.error("您还未开始营销，请在短信发送后可看营销效果");
            return;
          }
        }
        //在同一个智能营销中smartMarketingNodeId就是节点标识
        this.$data.nodeId = node.data.nodeId;
        this.$data.newNodeName = node.data.name;
        this.$data[category + "Visible"] = !this.$data[category + "Visible"];
        console.log("965284", this.$data[category + "Visible"]);
      }
    },
    //删除节点
    objectDelete(e) {
      if (this.edit && !this.$data.isReset) {
         let diagram = this.$refs.diag.diagram;
        //获取到选择多节点的数据
        var nodeOrLinkList = diagram.selection;
        var nodeNumList = [];
        nodeOrLinkList.each((nodeOrLink, index) => {
          nodeNumList.push(nodeOrLink.data);
        });
        if (nodeNumList.length > 1) {
          // 批量删除
          var nodeIds = [];
          var lineIds = [];
          nodeNumList.forEach((node, index) => {
            console.log("v=", node);
            if (nodeNumList[index].nodeId) {
              nodeIds.push(nodeNumList[index].nodeId);
            }
            if (nodeNumList[index].ids) {
              lineIds.push(nodeNumList[index].ids)
            }
          });
          var param = {
            nodeIds,
            lineIds
          }
          mnode.delBatchNode(param)
          .then((res) => {
            if (res.code === 1) {
              this.setinit();
            } else {
              this.$message.error(res.data);
              this.setinit();
            }
          });
          console.log('nodeIds:', nodeIds)
        } else {
             let node = e.diagram.selection.first();
        // let diagram = this.$refs.diag.diagram;
        // var nodeOrLinkDelectList = diagram.selection;
        // var nodeNumDelectList = [];
        // var targetGroupsLength = 0;
        // nodeOrLinkDelectList.each((v, index) => { 
        //   nodeNumDelectList.push(v.data);
        // });
          if (node instanceof this.$go.Node) {
            let noderel = [];
            //如果是抽取和排重的节点，生成的目标客户的节点都要移除
            if (
              node.data.category == "extraction" ||
              node.data.category == "unique"
            ) {
              //获取模型数据
              let model = this.model();
              //获取model在事务中执行
              model.startTransaction();
              //node.findNodesOutOf()查找节点的下一级节点
              //node.findNodesinto()查找节点的上一级节点
              //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
              node.findNodesOutOf().each((item) => {
                model.removeNodeData(item.data);
              });
              model.commitTransaction("updateStatus");
            }
            mnode
              .delNode({
                nodeId: node.data.nodeId,
              })
              .then((res) => {
                if (res.code === 1) {
                  this.setinit();
                } else {
                  this.$message.error(res.data);
                  this.setinit();
                }
              });
          }
          //Link线from和to
          if (node instanceof this.$go.Link) {
            mnode
              .delNodeRel({
                marketingId: this.$data.id,
                parentId: node.data.from,
                nodeId: node.data.to,
              })
              .then((res) => {
                if (res.code === 1) {
                  this.setinit();
                } else {
                  this.$message.error(res.message);
                  this.setinit();
                }
              });
          }
        // if (nodeNumDelectList.length > 1) {
        //   nodeNumDelectList.forEach((v, index) => {
        //     if (v.category == "targetGroups") {
        //       targetGroupsLength++;
        //     } else {
        //       var obj = {};
        //       if(nodeNumDelectList[index].nodeId){
        //         obj.nodeId=nodeNumDelectList[index].nodeId
        //       }else{
        //         return true       
        //       }  
        //       let noderel = [];
        //       //如果是抽取和排重的节点，生成的目标客户的节点都要移除
        //       // if (
        //       //   nodeNumDelectList[index].category == "extraction" ||
        //       //   nodeNumDelectList[index].category == "unique"
        //       // ) {
        //       //   //获取模型数据
        //       //   let model = this.model();
        //       //   //获取model在事务中执行
        //       //   model.startTransaction();
        //       //   //node.findNodesOutOf()查找节点的下一级节点
        //       //   //node.findNodesinto()查找节点的上一级节点
        //       //   //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
        //       //   node.findNodesOutOf().each((item) => {
        //       //     model.removeNodeData(item.data);
        //       //   });
        //       //   model.commitTransaction("updateStatus");
        //       // }
        //       setTimeout(()=>{
        //         mnode.delNode(obj).then((res) => {
        //         if (res.code === 1) {
        //         } else {
        //           this.$message.error(res.data);
        //           this.setinit();
        //         }
        //       });
        //       },500)
        //     }
        //   });
        //   (targetGroupsLength == nodeNumDelectList.length) && (this.$message.error("目标人群不能删除"))
        //   setTimeout(()=>{this.setinit();},3000)   
        // } else {
        //   if (node instanceof this.$go.Node) {
        //     let noderel = [];
        //     //如果是抽取和排重的节点，生成的目标客户的节点都要移除
        //     if (
        //       node.data.category == "extraction" ||
        //       node.data.category == "unique"
        //     ) {
        //       //获取模型数据
        //       let model = this.model();
        //       //获取model在事务中执行
        //       model.startTransaction();
        //       //node.findNodesOutOf()查找节点的下一级节点
        //       //node.findNodesinto()查找节点的上一级节点
        //       //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
        //       node.findNodesOutOf().each((item) => {
        //         model.removeNodeData(item.data);
        //       });
        //       model.commitTransaction("updateStatus");
        //     }
        //     mnode
        //       .delNode({
        //         nodeId: node.data.nodeId,
        //       })
        //       .then((res) => {
        //         if (res.code === 1) {
        //         } else {
        //           this.$message.error(res.data);
        //           this.setinit();
        //         }
        //       });
        //   }
        //   //Link线from和to
        //   if (node instanceof this.$go.Link) {
        //     mnode
        //       .delNodeRel({
        //         marketingId: this.$data.id,
        //         parentId: node.data.from,
        //         nodeId: node.data.to,
        //       })
        //       .then((res) => {
        //         if (res.code === 1) {
        //         } else {
        //           this.$message.error(res.message);
        //           this.setinit();
        //         }
        //       });
        //   }
        // }
        }
      }
    },
    readOnly() {
      this.info("恢复编辑可激活活动设计状态！");
    },
    info(message) {
      this.$notify.info({
        title: "消息",
        message: message,
      });
    },
    controllerClick(item) {
      if (item.name == "使用帮助") {
        window.open("https://www.yuque.com/yunduanxincrm/kb/ucmk4l", "_blank");
      }
      let type = item.icon;
      if (type == "reset" && this.editStatus == "1") {
        this.$message.info("活动状态为执行中不可恢复编辑");
        return;
      }
      this[type]();
    },
    //放大
    zoomOut() {
      let diagram = this.$refs.diag.diagram;
      if (diagram.commandHandler.canIncreaseZoom()) {
        diagram.commandHandler.increaseZoom();
      } else {
        this.$message.error("已经是最大了！");
      }
    },
    //缩小
    zoomIn() {
      let diagram = this.$refs.diag.diagram;
      if (diagram.commandHandler.canDecreaseZoom()) {
        diagram.commandHandler.decreaseZoom();
      } else {
        this.$message.error("已经是最小了！");
      }
    },
    //删除
    delete() {
      if (!this.$data.isReadOnly) {
        let diagram = this.$refs.diag.diagram;
        if (diagram.commandHandler.canDeleteSelection()) {
          diagram.commandHandler.deleteSelection();
        } else {
          this.$message.error("请选择要删除的节点！");
        }
      } else {
        this.readOnly();
      }
    },
    //预览小图
    preview() {
      this.$data.isOverview = !this.$data.isOverview;
      if (!this.$data.isov) {
        this.$data.isov = true;
        let diagram = this.$refs.diag.diagram;
        diagram.commandHandler.increaseZoom();
      }
    },
    //复制
    copy() {
      if (this.$data.isReadOnly) {
        this.readOnly();
        return;
      }
      //别删除，多个节点复制逻辑
      let diagram = this.$refs.diag.diagram;
      //获取到选择多节点的数据
      var nodeOrLinkList = diagram.selection;
      var nodeNumList = [];
      nodeOrLinkList.each((nodeOrLink, index) => {
        nodeNumList.push(nodeOrLink.data);
      });

      if (nodeNumList.length > 1) {
        // 选中复制多个

        var nodeIds = [];
        nodeNumList.forEach((v, index) => {
          console.log("v=", v);
          // let obj = {
          //   smartMarketingId: this.$data.id,
          //   smartMarketingNodeId: nodeNumList[index].smartMarketingNodeId,
          //   coordinate: nodeNumList[index].coordinate,
          // };
          if (nodeNumList[index].nodeId) {
            nodeIds.push(nodeNumList[index].nodeId);
          }
        });
        var param = {
          nodeIds,
          offsetAbscissa: 50, // 横坐标偏移量
          offsetOrdinate: 50, // 纵坐标偏移量
        };
        mnode.copyBatchNode(param).then((res) => {
          if (res.code === 1) {
            var list = res.data;
            list.map((item) => {
              (item.smartMarketingNodeId = item.id),
                (item.smartMarketingId = item.marketingId);
            });
            this.setinit(list);
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }

      if (!diagram.commandHandler.canCopySelection()) {
        diagram.commandHandler.copySelection();
        nodeNumList.forEach((v, index) => {
          if (nodeNumList[index].category !== "targetGroups") {
            console.log("v", v);
            nodeNumList[index].smartMarketingId = this.$data.id;
            let coordinate = nodeNumList[index].coordinate.split(" ");
            nodeNumList[index].coordinate = `${parseInt(coordinate[0]) +
              50},${parseInt(coordinate[1]) - 50}`;
            if (
              nodeNumList[index].name == "订单筛选" ||
              nodeNumList[index].name == "会员筛选" ||
              nodeNumList[index].name == "指定号码" ||
              nodeNumList[index].name == "高级分组" ||
              nodeNumList[index].name == "短信" ||
              nodeNumList[index].name == "等待" ||
              nodeNumList[index].type == "1" ||
              nodeNumList[index].type == "0" ||
              nodeNumList[index].type == "2" ||
              nodeNumList[index].type == "13" ||
              nodeNumList[index].type == "9" ||
              nodeNumList[index].type == "3"
            ) {
              let obj = {
                smartMarketingId: nodeNumList[index].smartMarketingId,
                smartMarketingNodeId: nodeNumList[index].nodeId,
                coordinate: nodeNumList[index].coordinate,
              };
              console.log("copyNode:", obj);
              mnode
                .copyNode(obj.smartMarketingNodeId, obj.coordinate)
                .then((res) => {
                  if (res.code === 1) {
                    let data = JSON.parse(JSON.stringify(nodeNumList[index]));
                    data.smartMarketingNodeId = data.key = res.data;
                    // data.isSaveContent = data.category === 'msg'
                    data.isSaveContent = false;
                    this.$data.nodeId = res.data;
                    delete data.__gohashid;
                    this.addNode(data);
                  }
                });
            }
          } else {
            mnode.addNode(node).then((res) => {
              if (res.code === 200) {
                let data = JSON.parse(JSON.stringify(nodeNumList[index]));
                data.smartMarketingNodeId = data.key = res.data;
                //   data.isSaveContent = data.category === "msg";
                this.$data.nodeId = res.data;
                delete data.__gohashid;
                this.addNode(data);
              }
            });
          }
        });
      } else {
        this.$message.error("目标人群节点不能复制！");
      }
    },
    //另存为
    saveAs() {
      this.$data.dialogTemplateFormVisible = !this.$data
        .dialogTemplateFormVisible;
    },
    //另存为确定
    saveAsTemplate() {
      this.$refs.formTemplate.validate((valid) => {
        if (valid) {
          this.$data.formTemplate.intelligentMarketingId = this.$data.id;
          mnode.addTemplate(this.$data.formTemplate).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.message);
              this.$data.dialogTemplateFormVisible = false;
              this.$data.formTemplate.name = "";
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改名称
    changedName(data) {
      //findNodeDataForKey通过节点key获取节点，知道节点key，拿到这个节点的详细信息
      let model = this.model();
      //所有方法都要在事务中进行
      model.startTransaction();
      //首先是拿到这个对象的属性进行修改，如果没有则新增这个属性
      /*****
       * setDataProperty(data,propname,val)
       * data:nodeData或者linkData
       * propname:属性名
       * val:修改的值
       */
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "name",
        data.name
      );
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "text",
        data.name
      );
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "isSaveContent",
        true
      );
      //提交当前事务的修改
      model.commitTransaction("updateName");
    },
    //销毁前清理定时器
    beforeDestroy() {
      activityInterval && clearInterval(activityInterval);
    },
  },
};
</script>
<style lang="less">
@import "./less/icons.less";
.page {
  padding: 0;
  .right-box-shodow {
    box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.05);
    width: 248px !important;
    user-select: none;
    overflow-x: hidden;
  }
  .el-collapse-item__header {
    text-align: left;
  }
  .el-collapse-item__content {
    padding-bottom: 16px;
    ul {
      padding-left: 0;
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
    }
    li {
      list-style: none;
      display: flex;
      align-items: center;
      width: 50%;
      margin-top: 15px;
      background: transparent;
    }
    li:nth-child(-n + 2) {
      margin-top: 0;
    }
  }
}
.padding-0 {
  padding: 0;
}
.padding-20 {
  padding-left: 20px;
}
.tools-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding: 16px 16px 16px 250px;
  position: relative;
  .tools-controller {
    display: flex;
    align-items: center;
    flex: 1;
    .btnf {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      left: 16px;
      top: 8px;
      .testpush {
        padding: 6px 12px;
        background: rgb(32, 98, 231);
        background-size: 20px;
        &:hover {
          background-color: #437ed9;
        }
        .icon {
        }
      }
      .officialpush {
        padding: 6px 12px;
        background: rgb(32, 98, 231);
        background-size: 20px;
        &:hover {
          background-color: #437ed9;
        }
      }
    }
  }
  .tools-btns {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.canvas-box {
  margin: 10px;
  overflow: hidden;
  border: 1px solid #e6e6e6;
}
canvas:focus {
  box-shadow: none;
  outline: none;
}
.nameTips {
  position: absolute;
  right: 15px;
  top: 0;
}
// .selectBox {
//   width: 100%;
//   display: flex;
//   position: relative;
// }
.switchover {
  position: absolute;
  right: 20px;
  top: -25px;
}
.lineBox {
  display: flex;
  align-items: center;
  margin-top: 10px;
  min-height: 32px;
  & .el-radio + .el-radio {
    margin-left: 3px;
  }
  & .el-badge__content.is-fixed {
    top: -7px;
  }
  & .el-checkbox-group .el-checkbox {
    margin-left: 10px;
  }
  & .el-checkbox-group .el-checkbox + .el-checkbox {
    margin-left: 10px;
  }
}
.lineBox:first-child {
  margin: 0;
}
.uploadTable {
  width: 100%;
  & td,
  & th {
    padding: 0 0;
  }
}
</style>
